import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Question from './question';

const CustomQuizMobile = ({ data, optionChange, displayResult }) => {
  const [question, setQuestion] = useState(0);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [questionData, setQuestionData] = useState({});

  useEffect(() => {
    setQuestionData(data[question]);
    setBtnDisabled(true);
  }, [question]);

  const handleChange = (e) => {
    optionChange(e);
    setBtnDisabled(false);
  };

  const handleNext = () => {
    if (question === data.length - 1) {
      displayResult();
    } else {
      setQuestion((prevState) => prevState + 1);
    }
  };

  return (
    <div className="quiz-items-wrapper quiz-items-wrapper--mobile">
      <Question
        question={questionData}
        questionNo={question + 1}
        handleChange={handleChange}
      />
      <div className="quiz-item quiz-item__next">
        <button
          className="btn btn-color"
          disabled={btnDisabled}
          onClick={handleNext}
        >
          <FormattedMessage id="dba.next" defaultMessage="Next" />
        </button>
      </div>
    </div>
  );
};

export default CustomQuizMobile;
